<ejs-sidebar id="sidebar-menu" #sidebarInstance type='Over' [width]='width' [position]='position'
             style="visibility: hidden" [enableGestures]="false" [showBackdrop]=true>

  <div class="offcanvas-close mt-n1 pr-5" style="float:right; padding: 48px;">
    <a href="javascript:;" class="btn btn-xs btn-icon btn-light btn-hover-primary" id="kt_quick_panel_close"
       (click)="closeSidebar()">
      <i class="ki ki-close icon-xs text-muted"></i>
    </a>
  </div>

  <div class='p-15'>
    <h2 *ngIf="!costCenterInput">Add Cost Center</h2>
    <h2 *ngIf="costCenterInput">Update Cost Center</h2>

    <form id="formId" [formGroup]="costCenterForm" #formDir="ngForm" class="form-horizontal" novalidate=""
          style="margin-top: 16px;">

      <div class="form-group sf-outline-input mb-10">
        <ejs-textbox id="cost_center_name" placeholder="Cost Center Name *" cssClass="e-filled"
                     formControlName="cost_center_name" floatLabelType="Auto"
                     (blur)="costCenterForm.controls.cost_center_name.markAsTouched()"
        ></ejs-textbox>
        <div *ngIf="costCenterForm.controls.cost_center_name.errors">
          <div
            *ngIf="costCenterForm.controls.cost_center_name.errors.required && costCenterForm.controls.cost_center_name.touched"
            class="e-error">
            Cost Center Name is required.
          </div>
        </div>
      </div>


      <div *ngIf="costCenterForm.invalid" class="e-error">Please fill all fields</div>
      <div *ngIf="error$ | async as error" class="e-error">{{error.error.message}}</div>

      <div class="my-10 pb-20">
        <button id="resetbtn"
                class="btn btn-outline-secondary text-uppercase font-weight-bold px-15 py-5 float-right btn-block mb-5"
                type="button"
                data-ripple="true" (click)="clear()">Clear
        </button>
        <button *ngIf="!costCenterInput" id="addSubmit"
                class="btn btn-primary text-uppercase font-weight-bold px-15 py-5 float-right btn-block" type="submit"
                (click)="onAddUpdateCostCenter(costCenterForm)" [disabled]="formSent" data-ripple="true"> Add
          Cost Center
        </button>
        <button *ngIf="costCenterInput" id="updateSubmit"
                class="btn btn-primary text-uppercase font-weight-bold px-15 py-5 float-right btn-block" type="submit"
                (click)="onAddUpdateCostCenter(costCenterForm, true)" [disabled]="formSent" data-ripple="true">
          Update Cost Center
        </button>
      </div>
    </form>
  </div>
</ejs-sidebar>

<ejs-dialog #clearModal [buttons]='dltButtons' header='Are you sure?' animationSettings='none' showCloseIcon='true'
            width='25%' [visible]='false'>
  <ng-template #content>
    <p>This action will clear all form fields.</p>
  </ng-template>
</ejs-dialog>
